import styled from '@emotion/styled';
import { CircularProgress, Typography } from '@material-ui/core';
import { Sparkles } from 'lucide-react';
import React from 'react';

const LoadingContainer = styled('div')<{ visible: boolean }>((p) => ({
  display: p.visible ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  gap: p.theme.spacing(1.5),
  padding: p.theme.spacing(2),
  marginBottom: p.theme.spacing(2),
  background: `linear-gradient(135deg, ${p.theme.palette.primary.light}15, ${p.theme.palette.primary.main}15)`,
  border: `1px solid ${p.theme.palette.primary.light}`,
  borderRadius: p.theme.custom.border.radius(),
  animation: 'fadeIn 0.3s ease-in-out',

  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-10px)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }
}));

const IconWrapper = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  color: p.theme.palette.primary.main,
  animation: 'pulse 2s ease-in-out infinite',

  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 1
    },
    '50%': {
      opacity: 0.5
    }
  }
}));

interface AIGeneratorLoadingIndicatorProps {
  state: 'idle' | 'generating' | 'inserting' | 'error';
}

export const AIGeneratorLoadingIndicator: React.FC<
  AIGeneratorLoadingIndicatorProps
> = ({ state }) => {
  const isVisible = state === 'generating' || state === 'inserting';

  const getMessage = () => {
    if (state === 'generating') {
      return 'AI is generating content...';
    }
    if (state === 'inserting') {
      return 'Building content blocks...';
    }
    return '';
  };

  return (
    <LoadingContainer visible={isVisible}>
      <IconWrapper>
        <Sparkles size={20} />
      </IconWrapper>
      <Typography variant="body2" color="primary">
        {getMessage()}
      </Typography>
      <CircularProgress size={16} />
    </LoadingContainer>
  );
};
